import React, {Component} from 'react';
import JednorazoweTable from "../../../konfiguracja/biletyConfig/biletyJednorazowe/components/JednorazoweTable";
import {TopButtonAdd} from "../../../../componentsTopsa/buttons/TopButtons";
import LSService from "../../../../utilities/localStorageService/LSService";
import BiletyService from "../../../konfiguracja/biletyConfig/biletyApi/BiletyService";
import ReactNotify from "react-notify";
import TopIf from "../../../../componentsTopsa/if/TopIf";
import {TopAlertUwaga} from "../../../../componentsTopsa/alerty/TopAlerts";
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import tabgrid from "../../../../utilities/TabGrid";
import InfoTooltip from "../../../../componentsTopsa/infoTooptip/InfoTooltip";
import {Link} from "react-router-dom";
import ReactTooltip from "react-tooltip";
import {Col, Row} from "react-bootstrap";
import acc from "accounting";
import StatusInTable from "../../../konfiguracja/biletyConfig/biletyJednorazowe/components/StatusInTable";
import GodzinaInTable from "../../../konfiguracja/biletyConfig/biletyJednorazowe/components/GodzinaInTable";
import KonfiguracjaService from "../../../administracja/konfiguracja/KonfiguracjaService";


export default class StronaKlientaTabJednorazowe extends Component {
    constructor(props) {
        super(props);
        this.state = {
            statusy: [
                {value: -1, label: 'do opłaty', ikona: 'fa fa-times-circle-o', kolor: '#333'},
                {value: 1, label: 'opłacony', ikona: 'fa fa-check-circle-o', kolor: '#333'},
                {value: 0, label: 'rezerwacja', ikona: 'fa fa-circle-o', kolor: '#333'},
                {value: 2, label: 'skasowany', ikona: 'fa fa-circle', kolor: '#333'},
                {value: -2, label: 'anulowano kl', ikona: 'fa fa-user-times', kolor: '#333'},
                {value: -3, label: 'anulowano op', ikona: 'fa fa-user-secret', kolor: '#333'},
                {value: -4, label: 'zwrócony', ikona: 'fa fa-refresh', kolor: '#333'},
                {value: -5, label: 'nieopłacony', ikona: 'fa fa-times', kolor: '#000'},
                {value: -6, label: 'płatność zwrócona', ikona: 'fa fa-refresh', kolor: '#111'},
            ],
        };
        this.onClickDodaj = this.onClickDodaj.bind(this)
        this.onChangeStatus = this.onChangeStatus.bind(this)
        this.onChangeGodzina = this.onChangeGodzina.bind(this)

        this.renderCena = this.renderCena.bind(this)
        this.renderDaneKlienta = this.renderDaneKlienta.bind(this)
        this.renderStatusy = this.renderStatusy.bind(this)
        this.renderDaneOdcinka = this.renderDaneOdcinka.bind(this)
        this.renderPlatnosc = this.renderPlatnosc.bind(this)
        this.renderZnizka = this.renderZnizka.bind(this)
    }

    componentDidMount() {
        this.pobierzKoloryStatusowBiletow()
    }

    componentWillReceiveProps(nextprops) {
        this.pobierzKoloryStatusowBiletow()
    }

    pobierzKoloryStatusowBiletow() {
        KonfiguracjaService.pobierzObiektySekcji('Status-kolor').then(function (response) {
            if (Boolean(response.data)) {

                let arr = response.data.filter(p => p.sekcja === 'Status-kolor')

                let statusyarr = this.state.statusy
                for (let i = 0; i < statusyarr.length; i++) {
                    let statuskolor = arr.find(p => p.pozycja == statusyarr[i].label)
                    if (Boolean(statuskolor)) {
                        statusyarr[i].kolor = statuskolor.wartosc
                    }
                }

                this.setState({statusy: statusyarr})

            }

        }.bind(this))
    }

    onClickDodaj(klient) {
        LSService.ustawDaneKlientaDoDodaniaJedn(Object.assign(klient, {imieNazwisko: klient.imie + ' ' + klient.nazwisko}))
        this.props.history.push('/konfiguracja/zarzadzanie-biletami/bilety/dodaj-jednorazowy')
    }

    onChangeStatus(status, obj) {
        BiletyService.editStatusWJednorazowym(obj.idBp, parseInt(status.value)).then(function (response) {
            if (response.status < 300) {
                this.refs.notificator.success('Pomyślnie zmieniono status biletu', "", 3000)
                this.props.handleOdswiezJednorazowe()
            }
            else {
                this.refs.notificator.error('Wystąpił błąd podczas zmiany statusu', "", 3000)
            }
        }.bind(this))
    }

    onChangeGodzina(idKu, obj) {
        BiletyService.editGodzinaWJednorazowym(obj.idBi, idKu).then(function (response) {
            if (response.status < 300) {
                this.refs.notificator.success('Pomyślnie zmieniono godzinę biletu', "", 3000)
                this.props.handleOdswiezJednorazowe()
            }
            else {
                this.refs.notificator.error('Wystąpił błąd podczas zmiany godziny', "", 3000)
            }
        }.bind(this))
    }

    czyZablokowacPrzycisk() {
        let czyZablokowac = false
        if (Boolean(this.props.klient)) {
            if (!this.props.klient.imie || !this.props.klient.nazwisko) {
                czyZablokowac = true
            }
        }
        else czyZablokowac = true

        return czyZablokowac

    }


    renderDaneOdcinka(cell, row) {
        return (
            <div>
                <div><span className={'label label-ebus-default'}>{row.nazTr}</span></div>
                <div style={{marginTop: '5px'}}>
                    <span>{row.nazMiOd}</span>
                    <i className={'fa fa-long-arrow-right'} style={{margin: '0 2px'}}></i>
                    <span>{row.nazMiDo}</span>
                </div>
            </div>
        )
    }

    renderDaneKlienta(cell, row) {

        if (row.idKl === 1) {     // gdy jest to jednorazowy klient
            return (
                <div title={'Klient Jednorazowy'}>
                    <div className={'pull-right'} title={'Miejsce sprzedaży'}>
                        <span style={{color: '#6cac3a', fontSize: '12px', fontStyle: 'italic'}}>{row.sprzedazMiejsce}</span>
                    </div>
                    <div>
                        <span className={'label label-ebus-default'}>K. Jednorazowy</span>
                        <div style={{marginTop: '3px'}}>
                            {row.klient}
                        </div>
                    </div>
                    <div style={{color: 'grey', fontSize: '12px', lineHeight: '1.1em', marginTop: '2px'}}>
                        {Boolean(row.klientTelefon) ? <span style={{display: 'inline-block', marginRight: '3px'}}><i
                            className={'fa fa-phone'}></i> {row.klientTelefon}</span> : ''}
                        {Boolean(row.klientEmail) ?
                            <span style={{display: 'inline-block'}}><i className={'fa fa-envelope'}></i> {row.klientEmail}</span> : ''}
                    </div>
                </div>
            )
        }
        else {
            // klient posiada konto

            // klient nie posiada uzupełnionego imienia i nazwiska (nazKl)
            if (!Boolean(row.nazKl)) {
                return (
                    <div title={'Bilet zakupiony na konto z nieuzupełnionymi danymi. Id konta: ' + row.idKl}>
                        <div className={'pull-right'} title={'Miejsce sprzedaży'}>
                            <span style={{color: '#6cac3a', fontSize: '12px', fontStyle: 'italic'}}>{row.sprzedazMiejsce}</span>
                        </div>
                        <div>
                            <i className={'fa fa-user'}
                               style={{marginRight: '5px', color: '#132239', textDecoration: 'none', fontSize: '12px'}}></i>
                            <Link to={'/zarzadzanie-klientami/klient/' + row.idKl} target={'_blank'}>
                                {row.klient}
                            </Link>
                        </div>
                        <div style={{color: 'grey', fontSize: '12px', lineHeight: '1.1em', marginTop: '5px'}}>
                            {Boolean(row.klientTelefon) ? <span style={{display: 'inline-block', marginRight: '3px'}}><i
                                className={'fa fa-phone'}></i> {row.klientTelefon}</span> : ''}
                            {Boolean(row.klientEmail) ? <span style={{display: 'inline-block'}}><i
                                className={'fa fa-envelope'}></i> {row.klientEmail}</span> : ''}
                        </div>
                    </div>
                )
            }
            else {
                return (   // dodane na klienta ktory posiada konto
                    <div>
                        <div data-tip='' data-for={'klient_data' + row.idKl + '-' + row.idBp} data-place="bottom" className='tooltip_here'>
                            <div style={{display: 'inline-block', lineHeight: '1.1em'}}>
                                {
                                    (row.nazKl == row.klient) ?
                                        <div>
                                            <div className={'pull-right'} title={'Miejsce sprzedaży'}>
                                                <span style={{color: '#6cac3a', fontSize: '12px', fontStyle: 'italic'}}>{row.sprzedazMiejsce}</span>
                                            </div>
                                            <div>
                                                <Link to={'/zarzadzanie-klientami/klient/' + row.idKl} target={'_blank'}>
                                                    {Boolean(row.nazKl) ? <span>{row.nazKl}</span> : ''}
                                                </Link>
                                            </div>
                                            <div style={{color: 'grey', fontSize: '12px', lineHeight: '1.1em', marginTop: '5px'}}>
                                                {Boolean(row.klientPesel) ? <span style={{display: 'inline-block', marginRight: '3px'}}><i
                                                    className={'fa fa-id-card-o'}></i> {row.klientPesel}</span> : ''}
                                                {Boolean(row.klientTelefon) ? <span style={{display: 'inline-block', marginRight: '3px'}}><i
                                                    className={'fa fa-phone'}></i> {row.klientTelefon}</span> : ''}
                                                {Boolean(row.klientEmail) ? <span style={{display: 'inline-block'}}><i
                                                    className={'fa fa-envelope'}></i> {row.klientEmail}</span> : ''}
                                            </div>
                                        </div>
                                        :
                                        <div>
                                            <div className={'pull-right'} title={'Miejsce sprzedaży'}>
                                                <span style={{color: '#6cac3a', fontSize: '12px', fontStyle: 'italic'}}>{row.sprzedazMiejsce}</span>
                                            </div>
                                            <div style={{cursor: 'pointer', color: '#2780e3', textDecoration: 'underline'}}>
                                                <i className={'fa fa-user'} title={'Pasażer - Bilet zakupiony na inne konto'}
                                                   style={{marginRight: '5px', color: '#132239', textDecoration: 'none', fontSize: '12px'}}></i>
                                                <Link to={'/zarzadzanie-klientami/klient/' + row.idKl} target={'_blank'}>
                                                    {row.klient}
                                                </Link>
                                            </div>
                                            <div style={{color: 'grey', fontSize: '12px', lineHeight: '1.1em', marginTop: '5px'}}>
                                                {Boolean(row.klientPesel) ? <span style={{display: 'inline-block', marginRight: '3px'}}><i
                                                    className={'fa fa-id-card-o'}></i> {row.klientPesel}</span> : ''}
                                                {Boolean(row.klientTelefon) ? <span style={{display: 'inline-block', marginRight: '3px'}}><i
                                                    className={'fa fa-phone'}></i> {row.klientTelefon}</span> : ''}
                                                {Boolean(row.klientEmail) ? <span style={{display: 'inline-block'}}><i
                                                    className={'fa fa-envelope'}></i> {row.klientEmail}</span> : ''}
                                            </div>
                                        </div>
                                }
                            </div>

                        </div>
                        <ReactTooltip id={'klient_data' + row.idKl + '-' + row.idBp}>
                            <Row>
                                <Col xs={12}>
                                    {
                                        (row.nazKl != row.klient) ?
                                            <div>
                                                Bilet zakupiony na konto:
                                            </div>
                                            :
                                            ''
                                    }

                                    <div>
                                        {
                                            Boolean(row.idKl) ?
                                                <div style={{lineHeight: '2em'}}><i className='fa fa-id-badge'
                                                                                    style={{marginRight: '5px'}}></i>Klient ID: {row.idKl}
                                                </div> : ''
                                        }
                                        {
                                            Boolean(row.nazKl) ?
                                                <div style={{lineHeight: '2em'}}><i className='fa fa-user'
                                                                                    style={{marginRight: '5px'}}></i> {row.nazKl}
                                                </div> : ''
                                        }{
                                        Boolean(row.klientPesel) ?
                                            <div style={{lineHeight: '2em'}}><i className='fa fa-id-card-o'
                                                                                style={{marginRight: '5px'}}></i>Pesel: {row.klientPesel}
                                            </div> : ''
                                    }
                                        {
                                            Boolean(row.klientTelefon) ?
                                                <div style={{lineHeight: '2em'}}><i className='fa fa-phone'
                                                                                    style={{marginRight: '5px'}}></i>Telefon: {row.klientTelefon}
                                                </div> : ''
                                        }
                                        {
                                            Boolean(row.klientEmail) ?
                                                <div style={{lineHeight: '2em'}}><i className='fa fa-envelope'
                                                                                    style={{marginRight: '5px'}}></i>Email: {row.klientEmail}
                                                </div> : ''
                                        }
                                    </div>
                                </Col>
                            </Row>

                        </ReactTooltip>
                    </div>
                )

            }
        }

    }

    renderPlatnosc(cell, row) {
        return (
            <div style={{fontSize: '12px'}}>
                {Boolean(row.dataWpisu) ?
                    <div title={"Data i godzina rejestracji transakcji biletu w systemie"}
                         style={{marginBottom: "5px", color: "grey", fontSize: "10px", fontStyle: "italic"}}><i
                        className={"fa fa-clock-o"}></i> {row.dataWpisu.replace("T", " ").substr(0, 19)}</div> : ""}
                <div>{Boolean(row.platnosciTransakcja) ? row.platnosciTransakcja : ''}</div>
                <div>{Boolean(row.platnoscTpay) ? row.platnoscTpay : ''}</div>
            </div>)
    }

    renderCena(cell, row) {
        return <div>
            <div>
            <span>{acc.formatMoney(row.cena * row.ile)}</span>
            {// jesli dana cena byla promocyjna
                Boolean(row.idPro) ?
                    <span style={{marginLeft: '7px', color: '#132239', background: '#eee'}} className={'label label-ebus-secondary'}
                          title={'Cena promocyjna'}><i className={'fa fa-tag'}></i> {row.idPro}</span>
                    : ''
            }
            <div style={{fontSize: '12px', color: 'grey'}}>
                {acc.formatMoney(row.cena)}/szt
            </div>
            </div>
            {
                (row.nipParagon!== null && row.nipParagon!=='') &&
                <div style={{
                    fontSize: '12px', fontStyle:'italic', marginTop: '3px'
                }}>
                    NIP: {row.nipParagon}
                </div>
            }
        </div>
    }

    renderStatusy(cell, row) {

        let status = this.state.statusy.find(s => s.value == row.statPoz)
        let formaplat = ''
        if (row.formaPlatn == 'GK') formaplat = 'gotówka'
        if (row.formaPlatn == 'KK') formaplat = 'karta'
        if (row.formaPlatn == 'PR') formaplat = 'przelew'
        if (Boolean(status)) {
            return <div>
                <StatusInTable status={status}
                               statusy={this.state.statusy}
                               idBp={row.idBp}
                               handleSelectStatus={(e) => this.onChangeStatus(e, row)}
                />
                {
                    row.statPoz === 2 || row.statPoz === -2 || row.statPoz === -4 ?
                        <div>
                            {
                                (row.statPoz === 2) ?
                                    <div style={{
                                        marginTop: '1px',
                                        marginLeft: '10px',
                                        color: 'grey',
                                        fontStyle: 'italic',
                                        fontSize: "12px"
                                    }}>Skasował: {(row.skasowalKierowca) ? row.skasowalKierowca : "-"}</div>
                                    :
                                    ""
                            }
                            {
                                (row.statPoz === -2) ?
                                    <div style={{
                                        marginTop: '1px',
                                        marginLeft: '10px',
                                        color: 'grey',
                                        fontStyle: 'italic',
                                        fontSize: "12px"
                                    }}>Anulowano: {(row.anulowanoData) ? row.anulowanoData.replace("T", " ").substr(0, 19) : "-"}</div>
                                    :
                                    ""
                            }
                            {
                                (row.statPoz === -4) ?
                                    <div style={{
                                        marginTop: '1px',
                                        marginLeft: '10px',
                                        color: 'grey',
                                        fontStyle: 'italic',
                                        fontSize: "12px"
                                    }}>Zwrot: {(row.zwrotProc) ? row.zwrotProc + "%" : "-"}, {(row.zwrotKwota) ? row.zwrotKwota + " zł" : "-"}</div>
                                    :
                                    ""
                            }
                        </div>
                        :
                        <div style={{marginTop: '1px', marginLeft: '10px', color: 'grey', fontStyle: 'italic', fontSize: "12px"}}>{formaplat}</div>

                }

            </div>
        }
    }

    renderZnizka(cell, row) {
        return <span className={'label label-ebus-default'} style={{color: '#fff', background: row.kolor}} title={row.nazZniz}>{cell}</span>
    }


    render() {

        const options = {
            sizePerPageList: [10, 15, 30,50],
            noDataText: 'Brak pasujących rekordów',
            sizePerPage: this.props.size,
            page: this.props.page,
            onSizePerPageList: this.props.handleOnSizeChange,
            onPageChange: this.props.handleOnPageChange,
        };

        return (
            <div>
                <ReactNotify ref='notificator'/>
                <div>
                    <div className={'pull-right'}>
                        <TopIf isTrue={this.czyZablokowacPrzycisk()}>
                            <TopAlertUwaga text={'Przed dodaniem biletu należy uzupełnić dane klienta'} inline={true}/> {' '}
                        </TopIf>
                        <TopButtonAdd onClick={() => this.onClickDodaj(this.props.klient)} buttonSize={'sm'} text={'Dodaj bilet jednorazowy'}
                                      disabled={this.czyZablokowacPrzycisk()}/>
                    </div>
                    <div style={{clear: 'both', height: '1px'}}></div>
                </div>
                <div>
                    <div className={'pull-right'} style={{fontSize: '12px', color: 'grey', padding: '5px', fontStyle: 'italic'}}>
                        Ilość wyszukanych rekordów: {Boolean(this.props.pageable) ? this.props.pageable.totalElements : 0}
                    </div>
                    <div>
                        <BootstrapTable data={this.props.jednorazowe}
                                        options={options}
                                        pagination
                                        hover
                                        fetchInfo={{dataTotalSize: this.props.pageable.totalElements}}
                                        remote={true}
                        >
                            <TableHeaderColumn dataField='idBi' isKey hidden={false} thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                            >Kod idBi</TableHeaderColumn>
                            <TableHeaderColumn dataField='waznyOd' thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                            >Ważny w</TableHeaderColumn>
                            <TableHeaderColumn dataField='godz' thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                               dataFormat={(cell, row) => cell.replace('.', ':')}
                            >Godz.</TableHeaderColumn>
                            <TableHeaderColumn dataField='infoOdcinek' thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                                               dataFormat={this.renderDaneOdcinka}
                            >Odcinek</TableHeaderColumn>
                            <TableHeaderColumn dataField='idKu' thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                            >Kurs</TableHeaderColumn>
                            <TableHeaderColumn dataField='klientInfo' thStyle={tabgrid.tg4} tdStyle={tabgrid.tg4}
                                               dataFormat={this.renderDaneKlienta}
                            >Pasażer i miejsce sprzedazy</TableHeaderColumn>
                            <TableHeaderColumn dataField='infoPlatnosci'
                                               thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                               dataFormat={this.renderPlatnosc}
                            >Transakcja</TableHeaderColumn>
                            <TableHeaderColumn dataField='ile' thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                            >ile</TableHeaderColumn>
                            <TableHeaderColumn dataField='cena'
                                               thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                               dataFormat={this.renderCena}
                            >Wartość</TableHeaderColumn>
                            <TableHeaderColumn dataField='rodz'
                                               thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                               dataFormat={this.renderZnizka}
                            >Rodzaj</TableHeaderColumn>
                            <TableHeaderColumn dataField='infoStatPoz'
                                               thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                                               dataFormat={this.renderStatusy}
                            >Status</TableHeaderColumn>
                        </BootstrapTable>
                    </div>
                </div>

            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/klienciConfig/stronaKlienta/components/StronaKlientaTabJednorazowe.js